import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createEmployee, updateEmployeeById, getEmployeeById } from "../../../../../services/employee.service";
import { TEmployeeForm, employeeSchema } from "./employeeSchema";
import { FormContainer, FormInput, Treturn } from "@4uhub/lib4uhub";
import { employeeItems } from "../employee.mock";

interface IEmployeeProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.employee.";

export const Employee = memo(({ id, onBackButton }: IEmployeeProps) => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createEmployee
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateEmployeeById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getEmployeeById
  //   );

  const saveHandler = async (v: TEmployeeForm) => {
    // save({
    //   ...v,
    // });
    return { data: {}, success: true };
  };

  const updateHandler = async (v: TEmployeeForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TEmployeeForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TEmployeeForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      //   return { data, success };

      const data = employeeItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const successHandle = () => {
    onBackButton();
  };

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TEmployeeForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "employee")}
      schema={employeeSchema}
      subtitle={t(translationPath + "new_employee")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={successHandle}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInput
              name="sector"
              label={t(translationPath + "sector")}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
